class {
    onCreate(input, out){
        this.state = {
            type: input.type,
            timeLeft: null
        }
    }
}

<script type="text/javascript">document.body.style.paddingBottom = '110px';</script>